import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const UploadContext = createContext(undefined);
export const useUploadContext = () => {
    const ctx = useContext(UploadContext);
    if (!ctx) {
        throw new Error('useUploadContext must be used within an UploadProvider');
    }
    return ctx;
};
/**
 * UploadProvider component provides a context for indicating that an upload is in progress.
 */
export const UploadProvider = ({ children }) => {
    const [uploading, setUploading] = useState(false);
    return (_jsx(UploadContext.Provider, { value: { uploading, setUploading }, children: children }));
};
